import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";

import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import NotificationsIcon from '@mui/icons-material/Notifications';

/////////////// API
import { getNotifications, readNotifications } from '../../Api/Notifications';


const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  maxWidth: 400,
  ...theme.applyStyles('dark', {
    backgroundColor: '#1A2027',
  }),
}));


const message = `Truncation should be conditionally applicable on this long line of text
 as this is a much longer line than what the container can support.`;

export default function ZeroWidthStack() {
  const navigate = useNavigate();

  const [notifications, setNotifications] = useState([])


  const listNotifications = useCallback (async () => {
    const res = await getNotifications()
    if(res) {
      setNotifications(res)
    }
  },[]);

  const navigateToNotification = async (data) => {
    const resRead = await readNotifications(data.id)
    if(resRead == 200) {
      if(data.data.length == 0 && data.model_name == 'Order') {
        navigate('/reports')
      }else if(data.data?.new_model && data.model_name == 'Order'){
        navigate('/OtherOrders')
      }else if(data.data?.car_manual == 1 && data.model_name == 'Order'){
        navigate('/OrderPricing')
      }else if(data.model_name == 'Complians'){
        navigate('/website/contactUs')
      }

      
    	
    }
  }
  
  
  useEffect(() => {
    listNotifications()
  }, [listNotifications])

  return (
    <Box sx={{ flexGrow: 1, overflow: 'hidden', px: 3 }}>
      {notifications.map((notification) => {
        return(
      <Item sx={{ my: 1, mx: 'auto', p: 2, maxWidth:'80% !important', cursor:'pointer' }} onClick={() => navigateToNotification(notification)}>
        <Stack spacing={2} direction="row" sx={{ alignItems: 'center' }}>
          <NotificationsIcon color='primary'/>
          <Typography noWrap>{notification.localized_message}</Typography>
          <Typography noWrap justifyContent='flex-end'>{notification.created_at_human	}</Typography>
          
        </Stack>
      </Item>
        )
      })}
    </Box>
  );
}
